import React, { useState, useContext } from "react";

import { ALL_PRODUCTS_QUERY } from "../../../graphql/Products/Products.graphql";

import { AddProductForm, EditProductForm } from "../../../components/Products";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { TABLE_COLUMNS, EXPORT_COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import ProductFilters from "./ProductFilters";

import { getFilterState, saveFilterState } from "../../../utils";

const ProductsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("PRODUCT_FILTERS", {});
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("PRODUCT_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  const { setModalOpen } = useContext(ModalContext);

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={ProductFilters}
        columns={EXPORT_COLUMNS}
        filters={filters}
        name="Products"
        query={ALL_PRODUCTS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Products"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddProductForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={TABLE_COLUMNS}
        dataQuery={ALL_PRODUCTS_QUERY}
        initialSortBy={[
          { id: "ProductCategory", desc: true },
          { id: "Description", desc: false }
        ]}
        name="Product"
        where={filters}
        onRowClick={product =>
          setModalOpen(
            true,
            <EditProductForm
              product={product}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};
export default ProductsPage;
